export const AboutMe = {
  FullName: "Tareq Harh",
  JobTitles: ["Full-Stack Developer", "Mechatronics Engineer"],
  Email: "harh.tareq@gmail.com",
  LinkedInLink: "https://www.linkedin.com/in/tareq-harh/",
  GitHubLink: "https://github.com/tareq-hrh",
  Address: "İstanbul, Türkiye",
  Languages: "Arabic, English, Turkish", // EX: "Arabic, English, Turkish"
  Interests: "Nature and outdoor activities",
  Sport: "Table Tennis", // EX: "Table Tennis"
  Image: "/images/MyPicture1-1.jpg",
  Description: (
    <>
      <p>
        I build modern web applications and business software, with a focus on
        ERP/CRM systems, data management, productivity tools, and AI-powered
        applications.
      </p>
      <br />
      <p>
        My engineering background shapes how I approach software: I model
        systems, break down complex problems, and turn requirements into
        practical solutions. Over time, that foundation led me deeper into
        full-stack development and modern web technologies.
      </p>
    </>
  ),
};
export const MyServices = [
  {
    Title: "Full-Stack Applications",
    Icon: "/images/ui-design.png",
    Points: (
      <ul>
        <li>• Modern responsive web applications</li>
        <li>• Frontend and backend integration</li>
        <li>• Authentication and application workflows</li>
        <li>• Maintainable application architecture</li>
      </ul>
    ),
  },
  {
    Title: "Business Systems & Automation",
    Icon: "/images/Solution.png",
    Points: (
      <ul>
        <li>• Internal business applications</li>
        <li>• ERP-style operational workflows</li>
        <li>• Relational data modeling</li>
        <li>• Workflow and process automation</li>
      </ul>
    ),
  },
  {
    Title: "APIs & Integrations",
    Icon: "/images/cloud-server.png",
    Points: (
      <ul>
        <li>• REST API development</li>
        <li>• Third-party service integrations</li>
        <li>• Real-time system communication</li>
        <li>• Connected data and integration workflows</li>
      </ul>
    ),
  },
];
